<template>
	<div class="chat-item" :class="active ? 'active' : ''" @contextmenu.prevent="showRightMenu($event)">
		<div class="chat-left">
			<head-image :url="conversation.headImage" :name="conversation.showName" :size="42"
				:id="isPrivate ? conversation.targetId : 0" :isShowUserInfo="false" :online="online"></head-image>
			<div v-show="!conversation.isDnd && conversation.unreadCount > 0" class="unread-text">{{
				conversation.unreadCount }}</div>
		</div>
		<div class="chat-right">
			<div class="chat-name">
				<div class="chat-name-text">
					<div>{{ conversation.showName }}</div>
					<span v-if="isGroup" class="im-tag im-tag-group">群聊</span>
					<span v-if="conversation.isTop" class="im-tag im-tag-top">置顶</span>
				</div>
				<div class="chat-time-text">{{ showTime }}</div>
			</div>
			<div class="chat-content">
				<div class="chat-at-text">{{ atText }}</div>
				<div class="chat-send-name" v-show="isShowSendName">{{ conversation.sendNickName + ':&nbsp;' }}</div>
				<div class="chat-content-text"
					v-html="$emo.transform($str.html2Escape(conversation.lastContent), 'emoji-small')"></div>
				<div class="icon iconfont icon-dnd" v-if="conversation.isDnd"></div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
	</div>

</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from '../common/RightMenu.vue';

export default {
	name: "chatItem",
	components: {
		HeadImage,
		RightMenu
	},
	data() {
		return {
		}
	},
	props: {
		conversation: {
			type: Object
		},
		active: {
			type: Boolean
		}
	},
	methods: {
		showRightMenu(e) {
			this.$refs.rightMenu.open(e, this.menuItems);
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.conversation);
		}
	},
	computed: {
		isShowSendName() {
			return !!this.conversation.sendNickName;
		},
		showTime() {
			return this.$date.toTimeText(this.conversation.lastSendTime, true)
		},
		atText() {
			if (this.conversation.atMe) {
				return "[有人@我]"
			} else if (this.conversation.atAll) {
				return "[@全体成员]"
			}
			return "";
		},
		menuItems() {
			let items = [];
			items.push({
				key: 'TOP',
				name: this.conversation.isTop ? '取消置顶' : '置顶'
			});
			if (this.conversation.isDnd) {
				items.push({
					key: 'DND',
					name: '新消息提醒'
				})
			} else {
				items.push({
					key: 'DND',
					name: '消息免打扰'
				})
			}
			items.push({
				key: 'DELETE',
				name: '删除聊天',
				danger: true
			})
			return items;
		},
		online() {
			if (this.isPrivate) {
				let friend = this.friendStore.findFriend(this.conversation.targetId);
				return friend && friend.online;
			}
			return false;
		},
		isPrivate() {
			return this.$enums.CONVERSATION_TYPE.PRIVATE == this.conversation.type
		},
		isGroup() {
			return this.$enums.CONVERSATION_TYPE.GROUP == this.conversation.type
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-item {
	height: 64px;
	display: flex;
	position: relative;
	margin: 0;
	padding: 10px 12px;
	align-items: center;
	background-color: var(--im-background);
	white-space: nowrap;
	cursor: pointer;
	border-radius: 0;
	transition: background-color 0.15s ease;

	&:hover {
		background-color: var(--im-background-active);
	}

	&.active {
		background-color: var(--im-background-active-dark);
	}

	.chat-left {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-shrink: 0;

		.unread-text {
			position: absolute;
			background-color: var(--im-color-danger);
			right: -6px;
			top: -4px;
			color: white;
			border-radius: 10px;
			padding: 0 5px;
			font-size: 10px;
			text-align: center;
			white-space: nowrap;
			border: 1.5px solid #fff;
			min-width: 18px;
			height: 18px;
			line-height: 15px;
			font-weight: 500;
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
		}

		.unread-dot {
			position: absolute;
			background-color: var(--im-color-danger);
			right: -2px;
			top: -2px;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			border: 1.5px solid #fff;
			box-sizing: border-box;
		}
	}


	.chat-right {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		padding-left: 12px;
		text-align: left;
		overflow: hidden;

		.chat-name {
			display: flex;
			line-height: 24px;
			height: 24px;
			margin-bottom: 2px;

			.chat-name-text {
				flex: 1;
				display: flex;
				align-items: center;
				font-size: var(--im-font-size);
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				color: var(--im-text-color);

				>div:first-child {
					overflow: hidden;
					text-overflow: ellipsis;
					max-width: 180px;
				}

				.im-tag {
					font-size: 10px;
					line-height: 14px;
					height: 14px;
					padding: 0 4px;
					border-radius: 2px;
					margin-left: 4px;
					flex-shrink: 0;
					font-weight: 500;
				}

				.im-tag-group {
					background: var(--im-color-primary-light-9);
					color: var(--im-color-primary);
				}

				.im-tag-top {
					background: #fff7e6;
					color: #fa9d3b;
				}
			}

			.chat-time-text {
				font-size: 11px;
				text-align: right;
				color: var(--im-text-color-light);
				white-space: nowrap;
				overflow: hidden;
				padding-left: 10px;
				flex-shrink: 0;
			}
		}

		.chat-content {
			display: flex;
			line-height: 20px;
			height: 20px;
			margin-top: 2px;
			align-items: center;

			.chat-at-text {
				color: var(--im-color-danger);
				font-size: var(--im-font-size-smaller);
				flex-shrink: 0;
				margin-right: 4px;
			}

			.chat-send-name {
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);
				flex-shrink: 0;
			}

			.chat-content-text {
				flex: 1;
				min-width: 0;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);
			}

			.icon {
				color: var(--im-text-color-light);
				flex-shrink: 0;
				margin-left: 4px;
			}
		}
	}
}
</style>
